import { interpolate, Easing } from "remotion";

// ── Cross-dissolve ─────────────────────────────────────────────────────────────

export const crossFadeIn = (frame: number, duration = 15) =>
  interpolate(frame, [0, duration], [0, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.cubic),
  });

export const crossFadeOut = (frame: number, total: number, duration = 15) =>
  interpolate(frame, [total - duration, total], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.in(Easing.cubic),
  });

// Fade in AND out — for scenes that need both ends dissolved
export const crossFade = (frame: number, total: number, duration = 15) =>
  Math.min(crossFadeIn(frame, duration), crossFadeOut(frame, total, duration));

// ── Flash cut (white flash between scenes) ────────────────────────────────────

export const flashWhiteIn = (frame: number, flashFrames = 6, fadeDuration = 18) =>
  interpolate(frame, [0, flashFrames, fadeDuration], [1, 1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.quad),
  });

export const flashWhiteOut = (frame: number, total: number, flashFrames = 6, fadeDuration = 18) =>
  interpolate(frame, [total - fadeDuration, total - fadeDuration + flashFrames, total], [0, 1, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.in(Easing.quad),
  });

// ── Slide wipe — returns clipPath string ──────────────────────────────────────

export type WipeDirection = "left" | "right" | "up" | "down";

export const slideWipeClip = (frame: number, duration = 20, direction: WipeDirection = "left"): string => {
  const pct = interpolate(frame, [0, duration], [0, 100], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.inOut(Easing.cubic),
  });
  const clips: Record<WipeDirection, string> = {
    left:  `inset(0 ${100 - pct}% 0 0)`,
    right: `inset(0 0 0 ${100 - pct}%)`,
    up:    `inset(0 0 ${100 - pct}% 0)`,
    down:  `inset(${100 - pct}% 0 0 0)`,
  };
  return clips[direction];
};

// ── Zoom punch (scale in from 1.15 to 1.0) ───────────────────────────────────

export const zoomPunchIn = (frame: number, duration = 12) =>
  interpolate(frame, [0, duration], [1.15, 1.0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.out(Easing.cubic),
  });

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
